export default __webpack_public_path__ + "static/media/logo-jira-product-discovery.e01706d4.svg";